import React, { FC, useCallback, useState } from 'react';
import PhotoAlbum from 'react-photo-album';
import { PhotoGalleryProps } from './PhotoGallery.types';
import { LightBox } from '@shared/components';

export const PhotoGallery: FC<PhotoGalleryProps> = props => {
  const { photos, layout = 'columns', onPhotoClick, columns, padding, spacing } = props;

  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState<number>(-1);

  const handlePhotoClick = useCallback(
    (index: number, mediaId: string, photoUrl: string) => {
      setSelectedPhotoIndex(index);
      onPhotoClick?.(mediaId, photoUrl);
    },
    [onPhotoClick]
  );

  return (
    <>
      <PhotoAlbum
        layout={layout}
        photos={photos}
        columns={columns}
        padding={padding}
        spacing={spacing}
        onClick={({ index, photo }) => handlePhotoClick(index, photo.mediaId, photo.src)}
        renderPhoto={({ wrapperStyle, renderDefaultPhoto }) => (
          <div style={{ ...wrapperStyle, backgroundColor: 'rgba(211,211,211,0.60)' }}>{renderDefaultPhoto({ wrapped: true })}</div>
        )}
      />
      <LightBox selectedPhotoIndex={selectedPhotoIndex} isOpen={selectedPhotoIndex >= 0} onClose={() => setSelectedPhotoIndex(-1)} photos={photos} />
    </>
  );
};

PhotoGallery.displayName = 'PhotoGallery';
